import React, { FC, useState } from 'react'
import WhatsappDocuments from './WhatsappDocuments'
import { useLocation } from 'react-router-dom'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { generateAddress, KTIcon, toAbsoluteUrl } from '../../../../../../../_metronic/helpers'

interface Dispatch {
    invoiceNumber: string
    quantityInfo: {
        quantity: number
        unit: string
    }
    dispatchedAt: string
    audit: {
        createdByName: string
        createdAt: string
    }
}

interface DispatchHistoryProps {
}

const DispatchHistory: FC<DispatchHistoryProps> = () => {
    const location = useLocation()
    const transactionData = (location.state as any)?.transactionData || null
    console.log("transactionData", transactionData)

    const [selectedDocs, setSelectedDocs] = useState<any[]>([]);

    const handleDocToggle = (docUrl: string, docType: string) => {
        const isSelected = selectedDocs.some(d => d.docUrl === docUrl);
        if (isSelected) {
            setSelectedDocs(selectedDocs.filter(d => d.docUrl !== docUrl));
        } else {
            setSelectedDocs([...selectedDocs, { docUrl, docType }]);
        }
    };

    const depositerName = [
        { label: 'Supplier Name', value: transactionData?.sellerInfo?.sellerName || "-" },
        { label: 'Identification', value: transactionData?.sellerInfo?.gstNumber || "-" },
        {
            label: 'Supplier Type',
            value: transactionData?.sellerInfo?.customerTypeDisplayName || "-"
        },
        {
            label: 'Collection Date',
            value: transactionData?.sellerInfo?.collectionDate || "-"
        },
        {
            label: 'Location',
            value: (transactionData?.sellerInfo?.address || "-"),
        },
    ]

    return (
        <div>

            <div className='table-responsive'>
                <table
                    className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'
                    style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginBottom: '20px',
                        border: "1px solid #ddd",
                    }}
                >
                    <thead>
                        <tr className='fw-bold bg-light'>
                            <th
                                style={{
                                    padding: '12px 10px',
                                    textAlign: 'left',
                                    border: '1px solid #FFF',
                                    color: "#FFF",
                                    backgroundColor: '#003B73',
                                    fontWeight: 600,
                                }}
                            >
                                Dispatch date
                            </th>
                            <th
                                style={{
                                    padding: '12px 10px',
                                    textAlign: 'left',
                                    border: '1px solid #FFF',
                                    color: "#FFF",
                                    backgroundColor: '#003B73',
                                    fontWeight: 600,
                                }}
                            >
                                Vehicle Number
                            </th>
                            <th
                                style={{
                                    padding: '12px 10px',
                                    textAlign: 'left',
                                    border: '1px solid #FFF',
                                    color: "#FFF",
                                    backgroundColor: '#003B73',
                                    fontWeight: 600,
                                }}
                            >
                                Invoice Number
                            </th>
                            <th
                                style={{
                                    padding: '12px 10px',
                                    textAlign: 'left',
                                    border: '1px solid #FFF',
                                    color: "#FFF",
                                    backgroundColor: '#003B73',
                                    fontWeight: 600,
                                }}
                            >
                                Category
                            </th>
                            <th
                                style={{
                                    padding: '12px 10px',
                                    textAlign: 'left',
                                    border: '1px solid #FFF',
                                    color: "#FFF",
                                    backgroundColor: '#003B73',
                                    fontWeight: 600,
                                }}
                            >
                                Item
                            </th>
                            <th
                                style={{
                                    padding: '12px 10px',
                                    textAlign: 'left',
                                    border: '1px solid #FFF',
                                    color: "#FFF",
                                    backgroundColor: '#003B73',
                                    fontWeight: 600,
                                }}
                            >
                                Grade
                            </th>
                            {/* <th
                            style={{
                                padding: '12px 10px',
                                textAlign: 'left',
                                border: '1px solid #FFF',
                                color: "#FFF",
                                backgroundColor: '#003B73',
                                fontWeight: 600,
                            }}
                        >
                            Seller Invoice
                        </th> */}
                            <th
                                style={{
                                    padding: '12px 10px',
                                    textAlign: 'left',
                                    border: '1px solid #FFF',
                                    color: "#FFF",
                                    backgroundColor: '#003B73',
                                    fontWeight: 600,
                                }}
                            >
                                Quantity (Kgs)
                            </th>
                        </tr>
                    </thead>
                    <tbody>

                        {transactionData?.sellerDispatch && transactionData?.sellerDispatch?.map((seller: any) =>
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                    <span className='text-dark fw-bold'>
                                        {seller?.dispatchedAt?.split("T")?.[0] || '-'}
                                    </span>
                                </td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                    <span className='text-dark'>
                                        {seller?.vehicleNo || '-'}
                                    </span>
                                </td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                    <span className='text-dark'>
                                        {seller?.invoiceNumber || '-'}
                                    </span>
                                </td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                    <span className='text-dark'>
                                        {seller?.materialInfo?.categoryName || '-'}
                                    </span>
                                </td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                    <span className='text-dark'>
                                        {seller?.materialInfo?.materialName || '-'}
                                    </span>
                                </td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                    <span className='text-dark'>
                                        {seller?.materialInfo?.grade || '-'}
                                    </span>
                                </td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                    <div className='d-flex flex-column'>
                                        <span className='text-dark fw-bold'>
                                            {seller?.quantityInfo?.quantity || '-'}
                                        </span>

                                    </div>
                                </td>
                            </tr>
                        )


                        }



                    </tbody>
                </table>
            </div>
            <div className='d-flex flex-wrap flex-lg-nowrap justify-content-between w-100 mt-8' style={{ gap: '24px' }}>
                {/* Left Info Card - Collection Receipt Design */}
                <div className='flex-grow-1' style={{ minWidth: '60%', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e1e9f1', overflow: 'hidden' }}>
                    {/* Header */}
                    <div style={{ backgroundColor: '#BFD7ED', padding: '16px 20px', color: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className='d-flex align-items-center gap-4'>
                            <div style={{ width: '50px', height: '50px', backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden', padding: '5px' }}>
                                <img src={toAbsoluteUrl('/media/avatars/dp.jpg')} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            </div>
                            <div>
                                <h2 className='m-0 fs-1 fw-bold text-[#003B73]'>Dispatch & Shipping Report</h2>
                                <div className='d-flex gap-4 mt-1 opacity-75 fs-7'>
                                    <span className='text-[#003B73]'>Document Number: <span className='fw-bold text-[#003B73]'>{transactionData?.transactionId || "-"}</span></span>
                                    <span className='text-[#003B73]'>Logged Date: <span className='fw-bold text-[#003B73]'>{transactionData?.sellerDispatch?.[0]?.dispatchedAt?.split("T")?.[0] || "-"}</span></span>
                                </div>
                            </div>
                        </div>
                        <div className='text-end h-100 d-flex flex-column justify-content-center'>
                            <div className='fw-bolder fs-2' style={{ letterSpacing: '2px', opacity: '0.9', color: '#003B73' }}>Plastics For Change</div>
                        </div>
                    </div>

                    <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        {/* Source of Waste Section */}
                        <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #e1e9f1', overflow: 'hidden' }}>
                            <div style={{ backgroundColor: '#BFD7ED', padding: '10px 15px', color: '#003B73', fontWeight: 'bold', fontSize: '15px' }}>
                                Seller Information
                            </div>
                            <div style={{ padding: '15px', display: 'flex', gap: '24px' }}>
                                <div style={{ flex: '1' }}>
                                    {[
                                        { label: 'Legal Name', value: transactionData?.sellerInfo?.sellerName || "N/A" },
                                        { label: 'GST No.', value: transactionData?.sellerInfo?.gstNumber || "N/A" },
                                        { label: 'Address', value: transactionData?.sellerInfo?.address || "N/A" },
                                    ].map((item, idx) => (
                                        <div key={idx} style={{ display: 'flex', padding: '10px 0', borderBottom: idx < 4 ? '1px solid #f1f5f9' : 'none' }}>
                                            <div style={{ width: '140px', color: '#242727', fontWeight: 'bold', fontSize: '14px' }}>{item.label}</div>
                                            <div style={{ color: '#242727', fontSize: '14px', flex: '1' }}>: {item.value || ''}</div>
                                        </div>
                                    ))}
                                </div>
                                {/* <div style={{ width: '260px', height: '180px', backgroundColor: '#f1f5f9', borderRadius: '10px', overflow: 'hidden', border: '1px solid #e2e8f0', position: 'relative' }}>
                                    <img src="/Users/Himanshu/.gemini/antigravity/brain/08fe62dd-2a21-44a5-b428-451b125ff63f/collection_receipt_map_1776844571160.png" alt="Map View" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                </div> */}
                            </div>
                        </div>

                        {/* Material Details Section */}
                        <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #e1e9f1', overflow: 'hidden' }}>
                            <div style={{ backgroundColor: '#BFD7ED', padding: '10px 15px', color: '#003B73', fontWeight: 'bold', fontSize: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                Material Details
                                <div className='d-flex gap-2'>
                                    <span style={{ backgroundColor: '#d5c9f5', color: '#6f42c1', padding: '4px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold' }}>{transactionData?.sellerDispatch?.[0]?.materialInfo?.grade}</span>
                                    {/* <span style={{ backgroundColor: '#d5c9f5', color: '#6f42c1', padding: '4px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold' }}>{transactionData?.materialSubCategory}</span> */}
                                </div>
                            </div>
                            <div className='p-0'>
                                <table className='table table-row-dashed table-row-gray-300 align-middle gs-7 gy-4 mb-0'>
                                    <thead>
                                        <tr className='fw-bold text-gray-800 border-bottom-1 fs-7'>
                                            <th className='min-w-50px text-center'>S.N</th>
                                            <th className='min-w-150px text-center'>Invoice No.</th>
                                            <th className='min-w-100px text-center'>Vehicle No.</th>
                                            <th className='min-w-100px text-center'>Category</th>
                                            <th className='min-w-80px text-center'>Item</th>
                                            <th className='min-w-100px text-center'>Quantity</th>
                                            <th className='min-w-80px text-center'>Unit Price</th>
                                            <th className='min-w-80px text-center'>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody className='fs-7'>
                                        {transactionData?.sellerDispatch?.map((seller: any, index: number) =>
                                            <tr>
                                                <td className='text-center'>{index + 1}</td>
                                                <td className='text-center text-dark fw-bold'>{seller?.invoiceNumber || "-"}</td>
                                                <td className='text-center'>{seller?.vehicleNo || "-"}</td>
                                                <td className='text-center'>{seller?.materialInfo?.categoryName || "-"}</td>
                                                <td className='text-center fw-bold'>{seller?.materialInfo?.materialName || "-"}</td>
                                                <td className='text-center'>{seller?.quantityInfo?.quantity || "-"}</td>
                                                <td className='text-center fw-bold'>{transactionData?.verifiedPurchasePriceInfo?.pricePerUnit || "-"}</td>
                                                <td className='text-center fw-bold'>{seller?.pricePaymentInfo?.totalAmount || "-"}</td>
                                            </tr>
                                        )}
                                        <tr className='border-top-2 border-secondary'>
                                            <td colSpan={5} className='text-end fs-4 fw-bolder pt-6 pe-10 text-dark'>Total</td>
                                            <td className='text-center fs-4 fw-bolder pt-6 text-dark'>{transactionData?.sellerDispatch?.reduce((total: number, seller: any) => total + seller?.quantityInfo?.quantity, 0)}</td>
                                            <td></td>
                                            <td className='text-center fs-4 fw-bolder pt-6 text-dark'>{transactionData?.sellerDispatch?.reduce((total: number, seller: any) => total + seller?.pricePaymentInfo?.totalAmount, 0)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* REMARKS Section */}
                        <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #e1e9f1', overflow: 'hidden' }}>
                            <div style={{ backgroundColor: '#BFD7ED', padding: '10px 15px', color: '#003B73', fontWeight: 'bold', fontSize: '15px' }}>
                                REMARKS
                            </div>
                            <div style={{ padding: '20px', color: '#7e8299', fontSize: '14px', fontStyle: 'italic' }}>
                                No remarks available
                            </div>
                        </div>

                        {/* Facility Information Section */}
                        <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #e1e9f1', overflow: 'hidden' }}>
                            <div style={{ backgroundColor: '#BFD7ED', padding: '10px 15px', color: '#003B73', fontWeight: 'bold', fontSize: '15px' }}>
                                Buyer Information
                            </div>
                            <div style={{ padding: '20px' }}>
                                <div style={{ display: 'flex', padding: '6px 0' }}>
                                    <div style={{ width: '140px', fontWeight: 'bold', color: '#242727', fontSize: '14px' }}>Legal Name</div>
                                    <div style={{ fontSize: '14px', color: '#4F5152' }}>: {transactionData?.buyerInfo?.buyerName}</div>
                                </div>
                                <div style={{ display: 'flex', padding: '6px 0', alignItems: 'flex-start' }}>
                                    <div style={{ width: '140px', fontWeight: 'bold', color: '#242727', fontSize: '14px' }}>GST No.</div>
                                    <div style={{ fontSize: '14px', color: '#4F5152', flex: '1' }}>: {transactionData?.buyerInfo?.gstNumber}</div>
                                </div>
                                <div style={{ display: 'flex', padding: '6px 0', alignItems: 'flex-start' }}>
                                    <div style={{ width: '140px', fontWeight: 'bold', color: '#242727', fontSize: '14px' }}>Address</div>
                                    <div style={{ fontSize: '14px', color: '#4F5152', flex: '1' }}>: {generateAddress(transactionData?.buyerInfo?.address?.[0])}</div>
                                </div>
                            </div>
                        </div>

                        {/* Shipping  Information */}
                        <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #e1e9f1', overflow: 'hidden' }}>
                            <div style={{ backgroundColor: '#BFD7ED', padding: '10px 15px', color: '#003B73', fontWeight: 'bold', fontSize: '15px' }}>
                                Shipping Information
                            </div>
                            <div style={{ padding: '20px' }}>
                                <div style={{ display: 'flex', padding: '6px 0' }}>
                                    <div style={{ width: '140px', fontWeight: 'bold', color: '#242727', fontSize: '14px' }}>Legal Name</div>
                                    <div style={{ fontSize: '14px', color: '#4F5152' }}>: {transactionData?.shippingInfo?.transporter}</div>
                                </div>
                                <div style={{ display: 'flex', padding: '6px 0', alignItems: 'flex-start' }}>
                                    <div style={{ width: '140px', fontWeight: 'bold', color: '#242727', fontSize: '14px' }}>Mode</div>
                                    <div style={{ fontSize: '14px', color: '#4F5152', flex: '1' }}>: {transactionData?.shippingInfo?.mode}</div>
                                </div>
                                <div style={{ display: 'flex', padding: '6px 0', alignItems: 'flex-start' }}>
                                    <div style={{ width: '140px', fontWeight: 'bold', color: '#242727', fontSize: '14px' }}>Distance</div>
                                    <div style={{ fontSize: '14px', color: '#4F5152', flex: '1' }}>: {transactionData?.shippingInfo?.distance}</div>
                                </div>
                                <div style={{ display: 'flex', padding: '6px 0', alignItems: 'flex-start' }}>
                                    <div style={{ width: '140px', fontWeight: 'bold', color: '#242727', fontSize: '14px' }}>Transport Cost</div>
                                    <div style={{ fontSize: '14px', color: '#4F5152', flex: '1' }}>: {transactionData?.shippingInfo?.transportCost}</div>
                                </div>
                                <div style={{ display: 'flex', padding: '6px 0', alignItems: 'flex-start' }}>
                                    <div style={{ width: '140px', fontWeight: 'bold', color: '#242727', fontSize: '14px' }}>Destination</div>
                                    <div style={{ fontSize: '14px', color: '#4F5152', flex: '1' }}>: {transactionData?.shippingInfo?.address}</div>
                                </div>
                            </div>
                        </div>

                        {/* Chain of Custody Section */}
                        {/* <div style={{ backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #e1e9f1', overflow: 'hidden' }}>
                            <div style={{ backgroundColor: '#BFD7ED', padding: '10px 15px', color: '#003B73', fontWeight: 'bold', fontSize: '15px' }}>
                                Chain of Custody
                            </div>
                            <div style={{ padding: '20px', display: 'flex', gap: '24px', alignItems: 'center' }}>
                                <div style={{ width: '150px', height: '150px', borderRadius: '12px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                                    <img src="/Users/Himanshu/.gemini/antigravity/brain/08fe62dd-2a21-44a5-b428-451b125ff63f/chain_of_custody_thumbnail_1776845090783.png" alt="Chain of Custody" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                </div>
                                <div>
                                    <h3 style={{ fontFamily: 'cursive', fontSize: '24px', color: '#003B73', marginBottom: '4px' }}>Akbar</h3>
                                    <div style={{ fontWeight: 'bold', fontSize: '16px', color: '#242727' }}>Signature</div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>

                {/* Right Documents Column */}
                <div className='d-flex flex-column' style={{ width: '100%', maxWidth: '320px', gap: '16px' }}>
                    {/* Sales Document Card */}
                    <div style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '12px',
                        padding: '16px',
                        border: '1px solid #f1f5f9',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
                    }}>
                        <div className='d-flex align-items-center mb-4'>
                            <span className='fs-5 fw-bold text-dark'>Sale Documents</span>
                        </div>
                        <div className='d-flex flex-wrap gap-3'>
                            {transactionData?.document?.filter?.((item: any) => item?.docType?.includes("BUYER"))?.length > 0 ? transactionData?.document?.filter?.((item: any) => item?.docType?.includes("BUYER"))?.map((doc: any, index: number) => (
                                <OverlayTrigger
                                    key={index}
                                    placement='top'
                                    overlay={<Tooltip id={`tooltip-buyer-${index}`}>{doc?.docType}</Tooltip>}
                                >
                                    <div className='d-flex flex-column align-items-center' style={{ cursor: 'pointer', position: 'relative' }}>
                                        <div style={{ position: 'absolute', top: '-5px', left: '-5px', zIndex: 10 }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedDocs.some(d => d.docUrl === doc.docUrl)}
                                                onChange={(e) => {
                                                    e.stopPropagation();
                                                    handleDocToggle(doc.docUrl, doc.docType);
                                                }}
                                                style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '-5px',
                                                right: '-5px',
                                                zIndex: 10,
                                                backgroundColor: '#fff',
                                                borderRadius: '50%',
                                                padding: '4px',
                                                border: '1px solid #e2e8f0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                doc?.docUrl && window.open(doc.docUrl, '_blank');
                                            }}
                                        >
                                            <i className='bi bi-eye-fill'></i>
                                        </div>
                                        <div style={{
                                            width: '64px',
                                            height: '64px',
                                            backgroundColor: '#f8fafc',
                                            borderRadius: '8px',
                                            border: '1px solid #e2e8f0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: '6px',
                                            transition: 'all 0.2s ease'
                                        }}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.borderColor = '#003B73';
                                                e.currentTarget.style.backgroundColor = '#f1f5f9';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.borderColor = '#e2e8f0';
                                                e.currentTarget.style.backgroundColor = '#f8fafc';
                                            }}
                                        >
                                            <KTIcon iconName='cloud-download' className='fs-2 text-primary' />
                                        </div>
                                        <span style={{ fontSize: '10px', color: '#64748b', fontWeight: '500' }}>{doc?.docType?.slice(0, 10)}</span>
                                    </div>
                                </OverlayTrigger>
                            )) : <div className='d-flex flex-wrap gap-3'>
                                <div className='w-100 text-center py-4 text-muted fs-7 border border-dashed rounded-3'>
                                    No documents available
                                </div>
                            </div>}
                        </div>
                    </div>

                    {/* Purchase Document Card */}
                    <div style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '12px',
                        padding: '16px',
                        border: '1px solid #f1f5f9',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
                    }}>
                        <div className='d-flex align-items-center mb-4'>
                            <span className='fs-5 fw-bold text-dark'>Purchase Documents</span>
                        </div>
                        <div className='d-flex flex-wrap gap-3'>
                            {transactionData?.sellerDispatch?.[0]?.document?.filter?.((item: any) => ["INVOICE_SELLER_PFC"].includes(item?.docType))?.length > 0 ? transactionData?.sellerDispatch?.[0]?.document?.filter?.((item: any) => ["INVOICE_SELLER_PFC"].includes(item?.docType))?.map((doc: any, index: number) => (
                                <OverlayTrigger
                                    key={index}
                                    placement='top'
                                    overlay={<Tooltip id={`tooltip-supplier-${index}`}>{doc?.docType}</Tooltip>}
                                >
                                    <div className='d-flex flex-column align-items-center' style={{ cursor: 'pointer', position: 'relative' }}>
                                        <div style={{ position: 'absolute', top: '-5px', left: '-5px', zIndex: 10 }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedDocs.some(d => d.docUrl === doc.docUrl)}
                                                onChange={(e) => {
                                                    e.stopPropagation();
                                                    handleDocToggle(doc.docUrl, doc.docType);
                                                }}
                                                style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '-5px',
                                                right: '-5px',
                                                zIndex: 10,
                                                backgroundColor: '#fff',
                                                borderRadius: '50%',
                                                padding: '4px',
                                                border: '1px solid #e2e8f0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                doc?.docUrl && window.open(doc.docUrl, '_blank');
                                            }}
                                        >
                                            <i className='bi bi-eye-fill'></i>
                                        </div>
                                        <div style={{
                                            width: '64px',
                                            height: '64px',
                                            backgroundColor: '#f8fafc',
                                            borderRadius: '8px',
                                            border: '1px solid #e2e8f0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: '6px',
                                            transition: 'all 0.2s ease'
                                        }}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.borderColor = '#003B73';
                                                e.currentTarget.style.backgroundColor = '#f1f5f9';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.borderColor = '#e2e8f0';
                                                e.currentTarget.style.backgroundColor = '#f8fafc';
                                            }}
                                        >
                                            <KTIcon iconName='cloud-download' className='fs-2 text-primary' />
                                        </div>
                                        <span style={{ fontSize: '10px', color: '#64748b', fontWeight: '500' }}>{doc?.docType?.slice(0, 10)}</span>
                                    </div>
                                </OverlayTrigger>
                            )) : <div className='d-flex flex-wrap gap-3'>
                                <div className='w-100 text-center py-4 text-muted fs-7 border border-dashed rounded-3'>
                                    No documents available
                                </div>
                            </div>}
                        </div>
                    </div>

                    {/* Quality & Certification Document Card */}
                    <div style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '12px',
                        padding: '16px',
                        border: '1px solid #f1f5f9',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
                    }}>
                        <div className='d-flex align-items-center mb-4'>
                            <span className='fs-5 fw-bold text-dark'>Quality & Certification Documents</span>
                        </div>
                        <div className='d-flex flex-wrap gap-3'>
                            {transactionData?.document?.filter?.((item: any) => ["GRS_TC_FROM_MANUFACTURER", "SUPPLIER_SCOPE_CERTIFICATE", "BUYER_SCOPE_CERTIFICATE"]?.includes(item?.docType))?.length > 0 ? transactionData?.document?.filter?.((item: any) => ["GRS_TC_FROM_MANUFACTURER", "SUPPLIER_SCOPE_CERTIFICATE", "BUYER_SCOPE_CERTIFICATE"]?.includes(item?.docType))?.map((doc: any, index: number) => (
                                <OverlayTrigger
                                    key={index}
                                    placement='top'
                                    overlay={<Tooltip id={`tooltip-other-${index}`}>{doc?.docType}</Tooltip>}
                                >
                                    <div className='d-flex flex-column align-items-center' style={{ cursor: 'pointer', position: 'relative' }}>
                                        <div style={{ position: 'absolute', top: '-5px', left: '-5px', zIndex: 10 }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedDocs.some(d => d.docUrl === doc.docUrl)}
                                                onChange={(e) => {
                                                    e.stopPropagation();
                                                    handleDocToggle(doc.docUrl, doc.docType);
                                                }}
                                                style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '-5px',
                                                right: '-5px',
                                                zIndex: 10,
                                                backgroundColor: '#fff',
                                                borderRadius: '50%',
                                                padding: '4px',
                                                border: '1px solid #e2e8f0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                doc?.docUrl && window.open(doc.docUrl, '_blank');
                                            }}
                                        >
                                            <i className='bi bi-eye-fill'></i>
                                        </div>
                                        <div style={{
                                            width: '64px',
                                            height: '64px',
                                            backgroundColor: '#f8fafc',
                                            borderRadius: '8px',
                                            border: '1px solid #e2e8f0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: '6px',
                                            transition: 'all 0.2s ease'
                                        }}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.borderColor = '#003B73';
                                                e.currentTarget.style.backgroundColor = '#f1f5f9';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.borderColor = '#e2e8f0';
                                                e.currentTarget.style.backgroundColor = '#f8fafc';
                                            }}
                                        >
                                            <KTIcon iconName='cloud-download' className='fs-2 text-primary' />
                                        </div>
                                        <span style={{ fontSize: '10px', color: '#64748b', fontWeight: '500' }}> {doc?.docType?.slice(0, 10)}</span>
                                    </div>
                                </OverlayTrigger>
                            )) : <div className='d-flex flex-wrap gap-3'>
                                <div className='w-100 text-center py-4 text-muted fs-7 border border-dashed rounded-3'>
                                    No documents available
                                </div>
                            </div>}
                        </div>
                    </div>

                    {/* Shipping Documents Card */}
                    <div style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '12px',
                        padding: '16px',
                        border: '1px solid #f1f5f9',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
                    }}>
                        <div className='d-flex align-items-center mb-4'>
                            <span className='fs-5 fw-bold text-dark'>Shipping Documents</span>
                        </div>
                        <div className='d-flex flex-wrap gap-3'>
                            {transactionData?.sellerDispatch?.reduce((acc: any, curr: any) => {
                                return acc.concat(curr.documentUrls)
                            }, [])?.length > 0 ?
                                transactionData?.sellerDispatch?.reduce((acc: any, curr: any) => {
                                    return acc.concat(curr.documentUrls)
                                }, []).map((doc: any, index: number) => (
                                    <OverlayTrigger
                                        key={index}
                                        placement='top'
                                        overlay={<Tooltip id={`tooltip-other-${index}`}>{doc?.docType}</Tooltip>}
                                    >
                                        <div className='d-flex flex-column align-items-center' style={{ cursor: 'pointer', position: 'relative' }}>
                                            <div style={{ position: 'absolute', top: '-5px', left: '-5px', zIndex: 10 }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedDocs.some(d => d.docUrl === doc.docUrl)}
                                                    onChange={(e) => {
                                                        e.stopPropagation();
                                                        handleDocToggle(doc.docUrl, doc.docType);
                                                    }}
                                                    style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                                                />
                                            </div>
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '-5px',
                                                    right: '-5px',
                                                    zIndex: 10,
                                                    backgroundColor: '#fff',
                                                    borderRadius: '50%',
                                                    padding: '4px',
                                                    border: '1px solid #e2e8f0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    doc?.docUrl && window.open(doc.docUrl, '_blank');
                                                }}
                                            >
                                                <i className='bi bi-eye-fill'></i>
                                            </div>
                                            <div style={{
                                                width: '64px',
                                                height: '64px',
                                                backgroundColor: '#f8fafc',
                                                borderRadius: '8px',
                                                border: '1px solid #e2e8f0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginBottom: '6px',
                                                transition: 'all 0.2s ease'
                                            }}
                                                onMouseOver={(e) => {
                                                    e.currentTarget.style.borderColor = '#003B73';
                                                    e.currentTarget.style.backgroundColor = '#f1f5f9';
                                                }}
                                                onMouseOut={(e) => {
                                                    e.currentTarget.style.borderColor = '#e2e8f0';
                                                    e.currentTarget.style.backgroundColor = '#f8fafc';
                                                }}
                                            >
                                                <KTIcon iconName='cloud-download' className='fs-2 text-primary' />
                                            </div>
                                            <span style={{ fontSize: '10px', color: '#64748b', fontWeight: '500' }}> {doc?.docType?.slice(0, 10)}</span>
                                        </div>
                                    </OverlayTrigger>))
                                : <div className='d-flex flex-wrap gap-3'>
                                    <div className='w-100 text-center py-4 text-muted fs-7 border border-dashed rounded-3'>
                                        No documents available
                                    </div>
                                </div>

                            }
                        </div>
                    </div>
                    <div className='mt-4'>
                        <WhatsappDocuments
                            selectedDocs={selectedDocs}
                            setSelectedDocs={setSelectedDocs}
                            orderId={transactionData?.transactionId}
                        />
                    </div>
                </div>
            </div>
            {/* Download Button */}
            <div className='mt-8 ps-1'>
                <button
                    className='btn hover-elevate-up'
                    style={{
                        backgroundColor: '#10b981',
                        color: 'white',
                        fontWeight: '600',
                        padding: '12px 32px',
                        borderRadius: '6px',
                        border: 'none',
                        fontSize: '14px',
                        boxShadow: '0 4px 10px rgba(16, 185, 129, 0.2)'
                    }}
                    onClick={() => window.print()}
                >
                    Download
                </button>
            </div>
        </div>
    )
}

export { DispatchHistory }
